import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { users } from '../invoices-error/db/users'
import { getAPIEndpointURL } from '../../../utility/utils'

const REACT_APP_API_QA_URL = getAPIEndpointURL()

const request = async (url, method, headers, data) => {
  // with fetch
  const response = await fetch(url, {
    method,
    headers,
    body: JSON.stringify(data),
  }).then((response) => response.json())
  return response
}

const getTemporalToken = async (user) => {
  const response = await request(
    `${REACT_APP_API_QA_URL}/api/auth/login`,
    'POST',
    {
      'Content-Type': 'application/json',
    },
    {
      userName: user.userName,
      password: user.password,
    }
  )

  return response?.access_token
}

export const getExcelReports = createAsyncThunk(
  'appExcelReports/getExcelReports',
  async (
    { filters, page = 0, size = 20, signal },
    { rejectWithValue }
  ) => {
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        mode: 'no-cors',
        signal,
      })
      const reports = await axiosInstance.post(
        '/api/reports-excel/documentos-emitidos/buscar',
        JSON.stringify(filters),
        {
          params: { page, size },
        }
      )

      if (
        typeof reports.data.success === 'boolean' &&
        !reports.data.success
      ) {
        return rejectWithValue(error.response?.data || error.message)
      }

      return {
        // data: (reports.data.content ?? []).map((item) => ({
        //   uuid: crypto.randomUUID(),
        //   ...item,
        // })),
        data: reports.data.content ?? [],
        totalPages: reports.data.page?.totalPages ?? 0,
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message)
      }

      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getExcelReportsFile = createAsyncThunk(
  'appExcelReports/getExcelReportsFile',
  async ({ filters, signal }, { rejectWithValue }) => {
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        mode: 'no-cors',
        signal,
      })
      const reports = await axiosInstance.post(
        '/api/reports-excel/documentos-emitidos/descargar',
        JSON.stringify(filters)
      )

      if (
        typeof reports.data.success === 'boolean' &&
        !reports.data.success
      ) {
        return rejectWithValue(error.response?.data || error.message)
      }

      return {
        data: reports.data.documentBase64,
        fileName: reports.data.fileName,
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message)
      }

      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

const initialState = {
  data: [],
  currentPage: 0,
  totalPages: 0,
  isPending: false,
}

export const appExcelReportSlice = createSlice({
  initialState,
  name: 'appExcelReports',
  reducers: {
    setInitialData: (state) => {
      state.data = []
      state.currentPage = 0
      state.totalPages = 0
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getExcelReports.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.totalPages = action.payload.totalPages
        state.isPending = false
      })
      .addCase(getExcelReports.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(getExcelReports.rejected, (state, action) => {
        state.data = []
        state.currentPage = 0
        state.totalPages = 0
        state.isPending = false
      })

      .addCase(getExcelReportsFile.fulfilled, (state, action) => {
        state.isPending = false
      })
      .addCase(getExcelReportsFile.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(getExcelReportsFile.rejected, (state, action) => {
        state.isPending = false
      }),
})

export const { setInitialData, setCurrentPage } =
  appExcelReportSlice.actions

export default appExcelReportSlice.reducer
